var render, staticRenderFns
import script from "./WidgetPortfolioVulnerabilities.vue?vue&type=script&lang=js&"
export * from "./WidgetPortfolioVulnerabilities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cc1a0aaa')) {
      api.createRecord('cc1a0aaa', component.options)
    } else {
      api.reload('cc1a0aaa', component.options)
    }
    
  }
}
component.options.__file = "src/views/dashboard/WidgetPortfolioVulnerabilities.vue"
export default component.exports